import { Button, Modal, TextInput } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { WarrantyLabor } from '../../Models/WarrantyLabor';

export default function EditWarrantyLaborModal({
  show,
  setShow,
  warrantyLabor,
  addUpdateWarrantyLabor,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  warrantyLabor: WarrantyLabor | null;
  addUpdateWarrantyLabor: (part: WarrantyLabor) => void;
}) {
  const [formData, setFormData] = useState<WarrantyLabor>({
    id: 0,
    warrantyId: 0,
    hours: 0,
    description: null,
    rate: null,
    total: 0,
  });

  const handleSetInitialValues = () => {
    const values = warrantyLabor
      ? {
          ...warrantyLabor,
        }
      : {
          id: 0,
          warrantyId: 0,
          hours: 0,
          description: null,
          rate: null,
          total: 0,
        };
    setFormData(values as WarrantyLabor);
  };

  useEffect(() => {
    handleSetInitialValues();
  }, [warrantyLabor, show]);

  const handleChangeInputLabor = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const onSubmit = async () => {
    if (!formData.hours) {
      toast.error('Unable to add item. Missing Hours.');
    } else {
      addUpdateWarrantyLabor(formData);
    }
  };

  function onCloseModal() {
    setShow(false);
  }

  return (
    <Modal show={show} size='4xl' onClose={onCloseModal} popup>
      <Modal.Header></Modal.Header>
      <Modal.Body>
        <div className='w-full'>
          <div className='w-full'>
            <div className='mx-1 flex items-end justify-center'>
              <div className='flex flex-1 justify-center'>
                <h1 className='text-gray-900 font-bold text-4xl'>
                  {warrantyLabor === null ? 'New' : 'Edit'} Labor
                </h1>
              </div>
            </div>
          </div>
          <div>
            <div className='container mx-auto p-2'>
              <div className='md:flex no-wrap md:-mx-2 '>
                <div className='w-full'>
                  <div className='bg-white'>
                    <hr className='bg-gray-300 h-[2px]'></hr>
                    <form>
                      <div className='flex flex-col md:flex-none md:grid md:grid-cols-[50%_50%] text-xl'>
                        <div>
                          <div className='grid grid-cols-[45%_55%] px-0 text-sm lg:px-2 md:text-md lg:text-lg'>
                            <div className='flex'>
                              <div className='text-md font-bold content-center'>
                                Hours:
                              </div>
                            </div>
                            <div className='w-full'>
                              <TextInput
                                id='hours'
                                name='hours'
                                type='text'
                                placeholder='Hours...'
                                onChange={handleChangeInputLabor}
                                value={formData.hours ?? ''}
                                sizing='md'
                              />
                            </div>
                          </div>
                          <div className='grid grid-cols-[45%_55%] px-0 text-sm lg:px-2 md:text-md lg:text-lg'>
                            <div className='flex'>
                              <div className='text-md font-bold content-center'>
                                Description:
                              </div>
                            </div>
                            <div className='w-full'>
                              <TextInput
                                id='description'
                                name='description'
                                type='text'
                                placeholder='Description...'
                                onChange={handleChangeInputLabor}
                                value={formData.description ?? ''}
                                sizing='md'
                              />
                            </div>
                          </div>
                          <div className='grid grid-cols-[45%_55%] px-0 text-sm lg:px-2 md:text-md lg:text-lg'>
                            <div className='flex'>
                              <div className='text-md font-bold content-center'>
                                Rate:
                              </div>
                            </div>
                            <div className='w-full'>
                              <TextInput
                                id='rate'
                                name='rate'
                                type='text'
                                placeholder='Rate...'
                                onChange={handleChangeInputLabor}
                                value={formData.rate ?? ''}
                                sizing='md'
                              />
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className='grid grid-cols-[45%_55%] px-0 text-sm lg:px-2 md:text-md lg:text-lg'>
                            <div className='flex'>
                              <div className='text-md font-bold content-center'>
                                Total:
                              </div>
                            </div>
                            <div className='w-full'>
                              <TextInput
                                id='total'
                                name='total'
                                type='text'
                                placeholder='Total...'
                                onChange={handleChangeInputLabor}
                                value={formData.total ?? ''}
                                sizing='md'
                                // onKeyDown={(event) => {
                                //   if (onlyNumberInput(event)) {
                                //     event.preventDefault();
                                //   }
                                // }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='flex justify-end pt-2'>
                        <Button
                          type='button'
                          className='buttonMain'
                          onClick={() => onSubmit()}
                        >
                          Save
                        </Button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
